<template>
  <!-- 维保阶段 -->
    <div class="bid-box">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="width:100%;height:100%;">
            <el-tab-pane label="项目施工类" name="first">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同类型">
                        <template slot-scope="scope">
                            <span>{{ scope.row.unitTypeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同编号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.serialNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="维保记录">
                        <template slot-scope="scope">
                            <div style="width:100%;display:flex;flex-wrap:wrap;">
                                <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in scope.row.returnVisit.list[0].files" :key="index" @click="showFile(item)">
                                    <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                    <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="管理服务类" name="second">
                <el-table
                    :data="listData1"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText1}}</p>
                    </template>
                    <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同类型">
                        <template slot-scope="scope">
                            <span>{{ scope.row.unitTypeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同编号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.serialNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="维保记录">
                        <template slot-scope="scope">
                            <div style="width:100%;display:flex;flex-wrap:wrap;">
                                <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in scope.row.returnVisit.list[0].files" :key="index" @click="showFile(item)">
                                    <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                    <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            listData:[],
            listData1:[],
            activeName:'first',
            dataText:'数据加载中...',
            dataText1:'数据加载中...',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        this.getData()
    },
    methods:{
        //获取项目施工类数据
        getData(){
            var that = this
            myHttp.selectProjectMaintentList({
                contractId:this.id,
                unitKind:'1'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list
                    for(var i=0;i<list.length;i++){
                        list[i].returnVisit = list[i].returnVisit?JSON.parse(list[i].returnVisit):{list:[{files:[]}]}
                        list[i].index = (i+1)
                    }
                    that.listData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        //获取管理服务类数据1
        getData1(){
            var that = this
            myHttp.selectProjectMaintentList({
                contractId:this.id,
                unitKind:'2'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list
                    for(var i=0;i<list.length;i++){
                        list[i].returnVisit = list[i].returnVisit?JSON.parse(list[i].returnVisit):{list:[{files:[]}]}
                        list[i].index = (i+1)
                    }
                    that.listData1 = list
                    if(list.length==0){
                        that.dataText1 = '暂无数据'
                    }
                }else{
                    that.dataText1 = '暂无数据'
                }
            })
        },
        //切换
        handleClick(e,event){
            if(e.index=='0'){
                this.getData()
            }else{
                this.getData1()
            }
        },

        //获取文件类型
        getIcon(url){
            var result = '';
            if(!url){
                result = ''
            }else{
                var list = url.split('.')
                var str = list[list.length-1]
                if(base.docType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/word.png')
                }else if(base.imgType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/photo.png')
                }else if(base.excelType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/excel.png')
                }else if(base.pdfType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/pdf.png')
                }else{
                    result = require('../../../assets/image/office/undefined.png')
                }
            }
            return result
        },
        //展示文件
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },

    }
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    .el-tabs__content{
        height: calc( 100% - 6vh );
    }
    .el-tab-pane{
        height: 100%;
    }
    .el-tabs__item{
        font-size: inherit;
    }
    .layui-table th{
        font-size: inherit;
        font-weight: bold;
        text-align: center;
    }

    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>